// extracted by mini-css-extract-plugin
export default {"recos":"P4-z","productCardOverride":"Q4-z","rowHasBadge":"R4-z"};